// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VIP_BlankPage__wrapper","container":"VIP_BlankPage__container"};